import { generateHookExports } from 'api/generateExports';
import { createCRUDService } from 'api/queryService';
import { API_CONFIG } from 'services/apiConfig';

let baseData = API_CONFIG.CUSTOMER_PROPERTY;
const BASE_URL = baseData?.path;
const QUERY_KEY = baseData?.queryKey;

const customerPropertyService = createCRUDService({
  baseUrl: BASE_URL,
  queryKey: QUERY_KEY,
});

export const {
  customerPropertyList,
  customerPropertyCreate,
  customerPropertyGetById,
  customerPropertyDownload,
  customerPropertyUpdate,
  customerPropertyUpdateSpecific,
  customerPropertyDelete,
} = generateHookExports(customerPropertyService, 'customerProperty');
